// extracted by mini-css-extract-plugin
export var clinics = "container-module--clinics--ibgdj";
export var doctor = "container-module--doctor--zY1YO";
export var ehealth = "container-module--ehealth--6Dm4N";
export var opport_head = "container-module--opport_head--Vwsyz";
export var opportunity_section = "container-module--opportunity_section--qVbk8";
export var patient = "container-module--patient--r+vPs";
export var section_content = "container-module--section_content--bMbq0";
export var text_icon_wrapper = "container-module--text_icon_wrapper--Q-2g0";